import { DEFAULT_LOCALE, getSupportedLocale } from './lang/lang';
import { importDisplayMessages } from './lang/services';

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
export const main = async (renderApp: (args: { locale: string; displayMessages: any }) => void) => {
    const userLocale = getSupportedLocale(navigator.language);
    const displayMessages = await importDisplayMessages(userLocale);

    // wait 300ms before rendering the app to make sure uikit css is loaded
    // setTimeout(() => {
    //     renderApp({ locale: userLocale, displayMessages: displayMessages });
    // }, 500);

    renderApp({ locale: userLocale, displayMessages: displayMessages });
};

export { DEFAULT_LOCALE };
